import { Text, Button } from 'components';
import { TextStyle } from 'components/Text/TextStyle';
import parse from 'html-react-parser';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    AbsoluteBackButton,
    AdditionalInformation,
    BottomBar,
    ProductContainer,
    ProductContentContainer,
    ProductImage,
    ProductTitle,
    Spacer,
} from './Product.style';
import { useProductVM } from './useProductVm';

const Product: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const { isError, product, currency, isLoading, handleAddProduct, goBack, amountWithCurrency } =
        useProductVM();

    if (isError || !product || !currency) {
        return <h1>{t('product_doesnt_exist')}...</h1>;
    }

    const { name, description, additionalInformation, image } = product;

    return (
        <ProductContainer>
            <AbsoluteBackButton onClick={goBack} data-testid="back-button" isPrimary={!image} />
            {image && <ProductImage url={image.fullUrl} />}
            {!image && <Spacer />}
            <ProductContentContainer>
                <ProductTitle text={name} noTranslation weight="bold" />
                {description && <TextStyle type="medium">{parse(description)}</TextStyle>}
                {additionalInformation && (
                    <>
                        <AdditionalInformation
                            text="product_additionalInformation"
                            weight="bold"
                            type="normal"
                        />
                        <TextStyle weight="medium">{parse(additionalInformation)}</TextStyle>
                    </>
                )}
            </ProductContentContainer>
            <BottomBar>
                <Button
                    fullWidth
                    isLoading={isLoading}
                    onClick={handleAddProduct}
                    data-testid="add-button"
                >
                    <Text
                        text="total_with_price"
                        values={{
                            amount: amountWithCurrency,
                        }}
                        weight="bold"
                    />
                </Button>
            </BottomBar>
        </ProductContainer>
    );
};

export default Product;
